/* Preserve the existing charger SKU's order properties on Horizon's native form. */
if (!customElements.get('myqji-purchase-metadata')) {
  customElements.define('myqji-purchase-metadata', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      try { this.catalog = JSON.parse(this.querySelector('script').textContent); }
      catch (_) { this.catalog = {}; }
      this.sync();
      document.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        this.sync(String(event.detail?.resource?.id || ''));
      }, { signal });
      document.addEventListener('submit', event => {
        if (event.target === this.form) this.sync();
      }, { capture: true, signal });
      // Native FormData, including the sticky CTA, retains the current variant's
      // metadata even when native variant rendering completes in the same turn.
      document.addEventListener('formdata', event => {
        if (event.target !== this.form) return;
        const row = this.catalog[String(event.formData.get('id') || '')];
        const names = new Set(Object.values(this.catalog).flatMap(value => Object.keys(value)));
        names.forEach(name => event.formData.delete(`properties[${name}]`));
        Object.entries(row || {}).forEach(([name, value]) => event.formData.set(`properties[${name}]`, value));
      }, { capture: true, signal });
    }
    get form() { return document.getElementById(this.dataset.formId); }
    sync(variantId) {
      const id = variantId === undefined ? this.form?.querySelector('input[name="id"]')?.value : variantId;
      const row = this.catalog[String(id || '')] || {};
      this.querySelectorAll('input[data-myqji-property]').forEach(input => input.remove());
      Object.entries(row).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${name}]`;
        input.value = value;
        input.setAttribute('form', this.dataset.formId);
        input.dataset.myqjiProperty = '';
        this.appendChild(input);
      });
      this.dataset.currentVariantId = String(id || '');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
